import { render, staticRenderFns } from "./Botao.vue?vue&type=template&id=2e2fa477"
import script from "./Botao.vue?vue&type=script&setup=true&lang=js"
export * from "./Botao.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports